var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50038 6.99996L8.50038 20C8.50038 20.552 8.05338 21 7.50038 21C6.94738 21 6.50038 20.552 6.50038 20L6.50038 6.91796L5.29038 8.47596C4.95138 8.91196 4.32238 8.99096 3.88738 8.65196C3.45038 8.31296 3.37138 7.68396 3.71038 7.24896L6.71038 3.38696C6.90138 3.13996 7.19638 2.99796 7.50938 2.99996C7.82038 3.00196 8.11338 3.14996 8.30038 3.39996L11.3004 7.39996C11.4354 7.57996 11.5004 7.79096 11.5004 7.99896C11.5004 8.30296 11.3624 8.60396 11.1004 8.79996C10.6584 9.13096 10.0314 9.04196 9.70038 8.59996L8.50038 6.99996ZM15.5004 16.9999L15.5004 3.99994C15.5004 3.44794 15.9474 2.99994 16.5004 2.99994C17.0534 2.99994 17.5004 3.44794 17.5004 3.99994L17.5004 17.0819L18.7104 15.5239C19.0494 15.0879 19.6784 15.0089 20.1134 15.3479C20.3674 15.5449 20.5004 15.8399 20.5004 16.1379C20.5004 16.3529 20.4324 16.5689 20.2904 16.7509L17.2904 20.6129C17.0994 20.8599 16.8044 21.0019 16.4914 20.9999C16.1804 20.9979 15.8874 20.8499 15.7004 20.5999L12.7004 16.5999C12.3694 16.1569 12.4584 15.5309 12.9004 15.1999C13.3424 14.8689 13.9694 14.9579 14.3004 15.3999L15.5004 16.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.53bd46c03d54ecbec553e9f0c0d8b3f0.svg";
export { ForwardRef as ReactComponent };